import { subtract, numDiv } from '@/utils/checkFormat.js'
import { taxationTypes } from '@/utils/const.js'

export const quteMixin = {
  data() {
    return {
      // 更多服务数据
      moreServeData: [
        {
          kindName: '道路救援',
          kindCode: 'T1',
          amount: '', // 保额
          discount: '', // 折扣系数
          premium: '报价后可见', // 实交保费
          calculateFlag: 'N12Y00', // 是否计入保额
          flag: '', // 标志字段（主险；附加险；）
          rate: '', // 费率
          basePremium: '', // 基础保费
          benchMarkPremium: '', // 基准保费
          riskCode: '050A',
          values: false, // 险别选择
          excessText: '选择次数', //
          layoutStyle: '1', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
          serviceTimes: {
            text: '请选择',
            code: ''
          }
        },
        {
          kindName: '安全检测',
          kindCode: 'T2',
          amount: '',
          discount: '', // 折扣系数
          premium: '报价后可见', // 实交保费
          calculateFlag: 'N12N00', // 是否计入保额
          flag: '', // 标志字段（主险；附加险；）
          rate: '', // 费率
          basePremium: '', // 基础保费
          benchMarkPremium: '', // 基准保费
          riskCode: '050A',
          values: false, // 险别选择
          excessText: '次数', // 显示保额还是免赔率
          layoutStyle: '2', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
          serviceTimes: '',
          precision: 0,
          integerLength: 3
        },
        {
          kindName: '代为驾驶',
          kindCode: 'T3',
          amount: '',
          discount: '', // 折扣系数
          premium: '报价后可见', // 实交保费
          calculateFlag: 'Y12Y00', // 是否计入保额
          flag: '', // 标志字段（主险；附加险；）
          rate: '', // 费率
          basePremium: '', // 基础保费
          benchMarkPremium: '', // 基准保费
          riskCode: '050A',
          values: false, // 险别选择
          excessText: '次数', // 显示保额还是免赔率
          layoutStyle: '2', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
          serviceTimes: '',
          precision: 0,
          integerLength: 3
        },
        {
          kindName: '代为送检',
          kindCode: 'T4',
          amount: '', // 保额
          discount: '', // 折扣系数
          premium: '报价后可见', // 实交保费
          calculateFlag: 'Y12Y00', // 是否计入保额
          flag: '', // 标志字段（主险；附加险；）
          rate: '', // 费率
          basePremium: '', // 基础保费
          benchMarkPremium: '', // 基准保费
          riskCode: '050A',
          values: false, // 险别选择
          excessText: '次数', // 显示保额还是免赔率
          layoutStyle: '2', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
          serviceTimes: '',
          precision: 0,
          integerLength: 3
        }
      ],
      // 商业险险别数据
      insurance: [
        {
          kindName: '机动车损失险',
          kindCode: 'A',
          amount: '', // 保额
          discount: '', // 折扣系数
          premium: '报价后可见', // 实交保费
          calculateFlag: 'Y11Y00', // 是否计入保额
          flag: '', // 标志字段（主险；附加险；）
          rate: '', // 费率
          basePremium: '', // 基础保费
          benchMarkPremium: '', // 基准保费
          riskCode: '050A',
          values: true, // 险别选择
          value: {
            text: '0元',
            code: '0'
          }, // 可选免赔额
          sdew: 'MA',
          accessoryRiskshow: false,
          layoutStyle: '1', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
          accessoryRisk: [
            {
              kindName: '车身划痕损失险',
              kindCode: 'L',
              amount: {
                text: '5000元',
                code: '5000'
              },
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'N12Y00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '保额', //
              layoutStyle: '1', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              showRisk: true
            },
            {
              kindName: '发动机进水损坏除外特约',
              kindCode: 'X2',
              amount: '',
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'N12N00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '', // 显示保额还是免赔率
              layoutStyle: '0', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              showRisk: true
            },
            {
              kindName: '车轮单独损失险',
              kindCode: 'C4',
              amount: {
                text: '请选择',
                code: ''
              },
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'Y12Y00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '保额', // 显示保额还是免赔率
              layoutStyle: '1', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              showRisk: true
            },
            {
              kindName: '绝对免赔率特约（车损险）',
              kindCode: 'FA',
              amount: '', // 保额
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'Y12Y00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '免赔率', // 显示保额还是免赔率
              layoutStyle: '1', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              deductibleRate: {
                text: '请选择',
                code: ''
              },
              showRisk: true
            }
          ]
        },
        {
          kindName: '第三者责任险',
          kindCode: 'B',
          holidays: false,
          Holidays: true,
          amountShow: true,
          amount: {
            text: '100万元',
            code: '1000000'
          }, // 保额
          discount: '', // 折扣系数
          premium: '报价后可见', // 实交保费
          calculateFlag: 'Y21Y00', // 是否计入保额
          flag: '', // 标志字段（主险；附加险；）
          rate: '', // 费率
          basePremium: '', // 基础保费
          benchMarkPremium: '', // 基准保费
          riskCode: '050A',
          values: true,
          value: '',
          sdew: 'MB',
          accessoryRiskshow: false,
          layoutStyle: '1', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
          accessoryRisk: [
            {
              kindName: '法定节假日限额翻倍险',
              kindCode: 'B2',
              amount: '',
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'N22Y00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '', // 显示保额还是免赔率
              layoutStyle: '4', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框, 为空)
              showRisk: true
            },
            {
              kindName: '车上货物责任险',
              kindCode: 'D2',
              amount: '',
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'N22Y00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '保额', // 显示保额还是免赔率
              layoutStyle: '2', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              showRisk: true,
              precision: 2,
              integerLength: 12
            },
            {
              kindName: '精神损害抚慰金责任险（三者险）',
              kindCode: 'R1',
              amount: '',
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'N12N00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '责任限额', // 显示保额还是免赔率
              layoutStyle: '2', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              showRisk: true,
              precision: 2,
              integerLength: 12
            },
            {
              kindName: '医保外医疗费用责任险（三者险）',
              kindCode: 'S1',
              amount: {
                text: '请选择',
                code: ''
              },
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'N12N00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '责任限额', // 显示保额还是免赔率
              layoutStyle: '1', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              showRisk: true
            },
            {
              kindName: '绝对免赔率特约（三者险）',
              kindCode: 'FB',
              amount: '', // 保额
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'Y12Y00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '免赔率', // 显示保额还是免赔率
              layoutStyle: '1', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              deductibleRate: {
                text: '请选择',
                code: ''
              },
              showRisk: true
            }
          ]
        },
        {
          kindName: '车上人员责任险（司机）',
          kindCode: 'D3',
          amountShow: true,
          amount: '', // 保额
          discount: '', // 折扣系数
          premium: '报价后可见', // 实交保费
          calculateFlag: 'Y21Y00', // 是否计入保额
          flag: '', // 标志字段（主险；附加险；）
          rate: '', // 费率
          basePremium: '', // 基础保费
          benchMarkPremium: '', // 基准保费
          riskCode: '050A',
          unitAmount: {
            text: '',
            code: ''
          }, // 每座保额
          seatCount: '1', // 座位数
          values: false,
          value: '',
          sdew: 'MD3',
          accessoryRiskshow: false,
          layoutStyle: '2', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
          precision: 2,
          integerLength: 6,
          accessoryRisk: [
            {
              kindName: '精神损害抚慰金责任险（司机）',
              kindCode: 'R2',
              amount: '',
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'N12N00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '责任限额', // 显示保额还是免赔率
              layoutStyle: '2', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              showRisk: true,
              precision: 2,
              integerLength: 12
            },
            {
              kindName: '医保外医疗费用责任险（司机）',
              kindCode: 'S2',
              amount: {
                text: '请选择',
                code: ''
              },
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'N12N00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '每次事故赔偿限额', // 显示保额还是免赔率
              layoutStyle: '1', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              showRisk: true
            },
            {
              kindName: '绝对免赔率特约（司机）',
              kindCode: 'FD3',
              amount: '', // 保额
              discount: '', // 折扣系数
              premium: '报价后可见', //   实交保费
              calculateFlag: 'Y12Y00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '免赔率', // 显示保额还是免赔率
              layoutStyle: '1', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              deductibleRate: {
                text: '请选择',
                code: ''
              },
              showRisk: true
            }
          ]
        },
        {
          kindName: '车上人员责任险（乘客）',
          kindCode: 'D4',
          amountShow: true,
          amount: '', // 保额
          discount: '', // 折扣系数
          premium: '报价后可见', // 实交保费
          calculateFlag: 'Y21Y00', // 是否计入保额
          flag: '', // 标志字段（主险；附加险；）
          rate: '', // 费率
          basePremium: '', // 基础保费
          benchMarkPremium: '', // 基准保费
          unitAmount: {
            text: '',
            code: ''
          }, // 每座保额
          seatCount: '', // 座位数
          riskCode: '050A',
          values: false,
          value: '',
          sdew: '',
          accessoryRiskshow: false,
          layoutStyle: '2', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
          precision: 2,
          integerLength: 6,
          accessoryRisk: [
            {
              kindName: '精神损害抚慰金责任险（乘客）',
              kindCode: 'R3',
              amount: '',
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'N12N00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '责任限额', // 显示保额还是免赔率
              layoutStyle: '2', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              showRisk: true,
              precision: 2,
              integerLength: 12
            },
            {
              kindName: '医保外医疗费用责任险（乘客）',
              kindCode: 'S3',
              amount: {
                text: '请选择',
                code: ''
              },
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'N12N00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '每次事故赔偿限额', // 显示保额还是免赔率
              layoutStyle: '1', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              showRisk: true
            },
            {
              kindName: '绝对免赔率特约（乘客）',
              kindCode: 'FD4',
              amount: '', // 保额
              discount: '', // 折扣系数
              premium: '报价后可见', // 实交保费
              calculateFlag: 'Y12Y00', // 是否计入保额
              flag: '', // 标志字段（主险；附加险；）
              rate: '', // 费率
              basePremium: '', // 基础保费
              benchMarkPremium: '', // 基准保费
              riskCode: '050A',
              values: false, // 险别选择
              excessText: '免赔率', // 显示保额还是免赔率
              layoutStyle: '1', // 布局风格(1:下拉, 2:input输入框, 3:两个输入框)
              deductibleRate: {
                text: '请选择',
                code: ''
              },
              showRisk: true
            }
          ]
        }
      ]
    }
  },
  methods: {
    // 页面渲染
    getDetail() {
      if (this.$store.state.baseInfo.startDate && this.$store.state.baseInfo.endDate) {
        if (this.$store.state.entrance === 1) {
          const now = new Date(new Date() * 1 + 24 * 60 * 60 * 1000) // 续保时间逻辑
          const data = now.getFullYear() + '/' + this.filtration(now.getMonth() + 1) + '/' + this.filtration(now.getDate())
          if (new Date(data) * 1 < new Date(this.$store.state.baseInfo.endDate) * 1) {
            const endDates = new Date(this.$store.state.baseInfo.endDate)
            const nows = new Date(new Date(this.$store.state.baseInfo.endDate) * 1 + 24 * 60 * 60 * 1000)
            const SYStartDate = nows.getFullYear() + '-' + this.filtration(nows.getMonth() + 1) + '-' + this.filtration(nows.getDate())
            const SYEndDate = endDates.getFullYear() + 1 + '-' + this.filtration(endDates.getMonth() + 1) + '-' + this.filtration(endDates.getDate())
            this.SYStartDate = SYStartDate
            this.SYEndDate = SYEndDate
          } else {
            this.setSYDefaultData()
          }
        } else {
          this.setSYDefaultData()
        }
      }
      if (this.$store.state.baseInfo.startDateCI && this.$store.state.baseInfo.endDateCI) {
        if (this.$store.state.entrance === 1) {
          const now = new Date(new Date() * 1 + 24 * 60 * 60 * 1000)
          const data = now.getFullYear() + '/' + this.filtration(now.getMonth() + 1) + '/' + this.filtration(now.getDate())
          if (new Date(data) * 1 < new Date(this.$store.state.baseInfo.endDateCI) * 1) {
            const endDateCIs = new Date(this.$store.state.baseInfo.endDateCI)
            const nows = new Date(new Date(this.$store.state.baseInfo.endDateCI) * 1 + 24 * 60 * 60 * 1000)
            const JQStartDate = nows.getFullYear() + '-' + this.filtration(nows.getMonth() + 1) + '-' + this.filtration(nows.getDate())
            const JQEndDate = endDateCIs.getFullYear() + 1 + '-' + this.filtration(endDateCIs.getMonth() + 1) + '-' + this.filtration(endDateCIs.getDate())
            this.JQStartDate = JQStartDate
            this.JQEndDate = JQEndDate
          } else {
            this.setJQDefaultData()
          }
        } else {
          this.setJQDefaultData()
        }
      }
      if (this.$store.state.carShipTax && this.$store.state.carShipTax.sumPayTax) {
        this.SumPayTax = this.$store.state.carShipTax.sumPayTax ? this.$store.state.carShipTax.sumPayTax : '0.00'
      }
      let business = 0
      if (Object.prototype.hasOwnProperty.call(this.$store.state, 'itemkindList') && this.$store.state.itemkindList.length > 0 && this.$store.state.itemkindList[0] && this.$store.state.itemkindList[0].kindCode) {
        this.insurance.forEach(value => {
          value.values = false
        })
        this.$store.state.itemkindList.forEach((item, i) => {
          this.switchValue = item.kindCode === 'BZ'
          this.insurance.forEach(value => {
            if (item.kindCode === value.kindCode) {
              business++
              value.values = true
              value.rate = item.rate || ''
              if (item.kindCode === 'A') {
                value.amount = item.amount || ''
                value.value = value.layoutStyle === '1' ? this.filterRiskArrData(item.kindCode, item.value, value.value) : value.amount || ''
              } else {
                value.amount = value.layoutStyle === '1' ? this.filterRiskArrData(item.kindCode, item.amount, value.amount) : item.amount || ''
                if (item.kindCode === 'D4') {
                  value.unitAmount.code = item.unitAmount
                  value.unitAmount.text = numDiv(item.unitAmount, 10000)
                  value.seatCount = this.actulResult.seatCount - 1
                }
                if (item.kindCode === 'D3') {
                  value.unitAmount.code = item.unitAmount
                  value.unitAmount.text = numDiv(item.unitAmount, 10000)
                  value.seatCount = '1'
                }
              }
            } else {
              value.accessoryRisk.forEach(kind => {
                if (kind.kindCode === item.kindCode) {
                  business++
                  kind.values = true
                  kind.rate = item.rate || ''
                  value.accessoryRiskshow = true
                  if (kind.excessText === '免赔率') {
                    kind.amount = item.amount || ''
                    kind.deductibleRate = kind.layoutStyle === '1' ? this.filterRiskArrData(item.kindCode, item.deductibleRate, kind.deductibleRate) : item.deductibleRate || ''
                  } else {
                    kind.amount = kind.layoutStyle === '1' ? this.filterRiskArrData(item.kindCode, item.amount, kind.amount) : item.amount || ''
                  }
                }
              })
            }
          })
          this.moreServeData.forEach(moreRisk => {
            if (item.kindCode === moreRisk.kindCode) {
              business++
              moreRisk.values = true
              moreRisk.rate = item.rate || ''
              moreRisk.amount = item.amount || ''
              moreRisk.serviceTimes = moreRisk.layoutStyle === '1' ? this.filterRiskArrData(item.kindCode, item.serviceTimes, moreRisk.serviceTimes) : item.serviceTimes || ''
            }
          })
        })
      } else {
        business = -1
      }
      if (this.$store.state.insuredFeeList && this.$store.state.insuredFeeList[0] && this.$store.state.insuredFeeList[0].amount !== '' && this.$store.state.insuredFeeList.length !== 0) {
        this.$store.state.insuredFeeList.forEach(value => {
          if (value.kindCode === 'BZ') {
            this.plusPremium = value.premium
          }
          this.insurance.forEach(item => {
            if (item.kindCode === value.kindCode) {
              item.premium = value.premium || ''
            } else {
              item.accessoryRisk.forEach(kind => {
                if (kind.kindCode === value.kindCode) {
                  kind.premium = value.premium || ''
                }
              })
            }
          })
          this.moreServeData.forEach(moreRisk => {
            if (moreRisk.kindCode === value.kindCode) {
              moreRisk.premium = value.premium || ''
            }
          })
        })
      }
      if (this.$store.state.planList && this.$store.state.planList[0]) {
        if (this.alter === false) {
          this.SYpremium = '0.00'
        } else {
          this.$store.state.planList.forEach(item => {
            if (item.planText === '商业险保费合计') {
              this.SYpremium = item.planFee
            }
          })
        }
      }
      if (business === 0) {
        this.alter = false
      }
      const adds = ['extendChar2', 'taxComName', 'taxRelifFlag', 'paidFreeCertificate', 'taxDocumentDate', 'sumPayTax', 'taxPaidAreaCode', 'taxComCode']
      adds.forEach((value, index) => {
        if (Object.prototype.hasOwnProperty.call(this.$store.state.carShipTax, value) && this.$store.state.carShipTax[value] !== null && this.$store.state.carShipTax[value] !== '') {
          if (value === 'taxRelifFlag') {
            this.taxRelifFlagnae = taxationTypes[subtract(Number(this.$store.state.carShipTax[value]), 1)].text
            this.taxRelifInfo.hfCode = this.$store.state.carShipTax[value]
          } else {
            if (this.$store.state.carShipTax.taxRelifFlag !== '4') {
              this.taxRelifInfo[value] = this.$store.state.carShipTax[value]
            }
          }
        }
      })
    },
    // 确认时间选择
    sureHour(value) {
      if (this.status === 'TrafficStart') {
        this.price = false // 是否已报价
        const now = new Date(value)
        const year = now.getFullYear() + 1
        const month = this.filtration(now.getMonth() + 1)
        const daa = this.filtration(now.getDate())
        const hour = this.filtration(now.getHours())
        this.JQStartDate = now.getFullYear() + '-' + month + '-' + daa
        if (this.calculateFlag === '2') {
          this.realValueJQ(this.JQStartDate)
        }
        this.JQStartHour = hour
        this.JQStartMinute = this.filtration(now.getMinutes())
        const timejq = new Date(now * 1 - 24 * 60 * 60 * 1000)
        if (hour === '00' && this.JQStartMinute === '00') {
          if (now.getFullYear() % 4 === 0 && month === '03' && String(daa) === '01') {
            this.JQEndDate = year + '-' + '02' + '-' + '28'
          } else if (now.getFullYear() % 4 === 3 && month === '03' && String(daa) === '01') {
            this.JQEndDate = year + '-' + '02' + '-' + '29'
          } else {
            this.JQEndDate = timejq.getFullYear() + 1 + '-' + this.filtration(timejq.getMonth() + 1) + '-' + this.filtration(timejq.getDate())
          }
          this.JQEndHour = '24'
          this.JQEndMinute = '00'
        } else {
          if (now.getFullYear() % 4 === 0 && month === '02' && String(daa) === '29') {
            this.JQEndDate = year + '-' + '02' + '-' + '28'
          } else {
            this.JQEndDate = now.getFullYear() + 1 + '-' + this.filtration(now.getMonth() + 1) + '-' + this.filtration(now.getDate())
          }
          this.JQEndHour = '24'
          this.JQEndMinute = '00'
        }
        const time = new Date() * 1
        const times = now * 1
        if (times - time <= 15 * 60 * 1000) {
          this.$toast('您选择的起保时间即将生效，请尽快完成。')
        }
        // 如果是根据上年止期带入，则不联动商业险起期
        if (!this.joinJq) {
          this.SYStartDate = this.JQStartDate
          this.SYStartHour = this.JQStartHour
          this.SYEndDate = this.JQEndDate
          this.SYEndHour = this.JQEndHour
          this.SYStartMinute = this.JQStartMinute
        }
        if (!this.alter) {
          this.startTime = `${this.JQStartDate} ${this.JQStartHour}时${this.JQStartMinute}分`
          this.endTime = `${this.JQEndDate} ${this.JQEndHour}时${this.JQEndMinute}分`
        }
        this.$store.commit('setAlter', '3')
      } else if (this.status === 'BusinessStart') {
        this.price = false
        const nowsy = new Date(value)
        const hoursy = this.filtration(nowsy.getHours())
        this.SYStartDate = nowsy.getFullYear() + '-' + this.filtration(nowsy.getMonth() + 1) + '-' + this.filtration(nowsy.getDate())
        if (this.calculateFlag === '0' || this.calculateFlag === '1') {
          this.realValueJQ(this.SYStartDate)
        }
        this.SYStartHour = hoursy
        this.SYStartMinute = this.filtration(nowsy.getMinutes())
        const timesy = new Date(nowsy * 1 - 24 * 60 * 60 * 1000)
        if (hoursy === '00') {
          if (nowsy.getFullYear() % 4 === 0 && this.filtration(nowsy.getMonth() + 1) === '03' && String(this.filtration(nowsy.getDate())) === '01') {
            this.SYEndDate = nowsy.getFullYear() + 1 + '-' + '02' + '-' + '28'
          } else if (nowsy.getFullYear() % 4 === 3 && this.filtration(nowsy.getMonth() + 1) === '03' && String(this.filtration(nowsy.getDate())) === '01') {
            this.SYEndDate = nowsy.getFullYear() + 1 + '-' + '02' + '-' + '29'
          } else {
            this.SYEndDate = timesy.getFullYear() + 1 + '-' + this.filtration(timesy.getMonth() + 1) + '-' + this.filtration(timesy.getDate())
          }
        } else {
          if (nowsy.getFullYear() % 4 === 0 && this.filtration(nowsy.getMonth() + 1) === '02' && String(this.filtration(nowsy.getDate())) === '29') {
            this.SYEndDate = nowsy.getFullYear() + 1 + '-' + '02' + '-' + '28'
          } else {
            this.SYEndDate = nowsy.getFullYear() + 1 + '-' + this.filtration(nowsy.getMonth() + 1) + '-' + this.filtration(nowsy.getDate())
          }
        }
        this.SYEndHour = '24'
        this.SYEndMinute = '00'
        const timeB = new Date() * 1
        const timesB = nowsy * 1
        if (timesB - timeB <= 15 * 60 * 1000) {
          this.$toast('您选择的起保时间即将生效，请尽快完成。')
        }
        this.$store.commit('setAlter', '3')
      } else if (this.status === 'choice') {
        this.price = false
        this.$store.commit('setAlter', '3')
        const nowsys = new Date(value)
        this.taxRelifInfo.taxDocumentDate = nowsys.getFullYear() + '-' + this.filtration(nowsys.getMonth() + 1) + '-' + this.filtration(nowsys.getDate())
      }
      this.popupTimeVisible = false
      this.popupDateVisible = false
    },
    radioChange(value) {
      if (value === '1') {
        this.underwriting.profitRate = ''
      }
      this.price = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/car/newQuote/Mixin/mixin.js